var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.link ? "a" : "div",
    {
      tag: "component",
      class: ["z-card", _vm.classObject],
      style: _vm.backgroundImage
        ? "background-image: url(" + _vm.backgroundImage
        : "",
      attrs: { href: _vm.link },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("div", { staticClass: "z-card__body" }, [
        this.$slots["top"]
          ? _c("header", { staticClass: "z-card__header" }, [_vm._t("top")], 2)
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "z-card__main" }, [
          this.$slots["title"]
            ? _c("span", { staticClass: "z-card__title" }, [_vm._t("title")], 2)
            : _vm._e(),
          _vm._v(" "),
          this.$slots["content"]
            ? _c(
                "div",
                { staticClass: "z-card__content" },
                [_vm._t("content")],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        this.$slots["bottom"]
          ? _c(
              "footer",
              { staticClass: "z-card__footer" },
              [_vm._t("bottom")],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }